module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart":"График","disclose":"Раскрыть","intensity":"Интенсивность","modal-title":"График проезда ТС"},"en":{"chart":"Chart","disclose":"Disclose","intensity":"Intensity","modal-title":"Vehicle route schedule"}}')
  delete Component.options._Ctor
}
